import { render, staticRenderFns } from "./OverlayRoomInfos.vue?vue&type=template&id=ec128e82&scoped=true"
import script from "./OverlayRoomInfos.vue?vue&type=script&lang=js"
export * from "./OverlayRoomInfos.vue?vue&type=script&lang=js"
import style0 from "./OverlayRoomInfos.vue?vue&type=style&index=0&id=ec128e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec128e82",
  null
  
)

export default component.exports